import { render, staticRenderFns } from "./PassBlock.vue?vue&type=template&id=d76fba88"
import script from "./PassBlock.vue?vue&type=script&lang=ts"
export * from "./PassBlock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports